import React from "react";
import CustomForm from "../components/formBuilder/CustomForm";
import "./OnBoardingForm.scss";

function OnBoardingForm({ jsonSchema, postFormData, preFillData }) {
  return (
    <div styleName="form-container">
      {preFillData && (
        <React.Fragment>
          <CustomForm
            formData={jsonSchema?.formData}
            onSubmitHandler={(val) => {
              postFormData(val);
            }}
            formName={jsonSchema?.formName}
            initialValues={{ data: preFillData?.[0]?.response }}
          />
        </React.Fragment>
      )}
    </div>
  );
}

export default OnBoardingForm;
